import { render, staticRenderFns } from "./CompletedTodoView.vue?vue&type=template&id=b0c6468c&"
import script from "./CompletedTodoView.vue?vue&type=script&lang=js&"
export * from "./CompletedTodoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports